// Build 20260909-324: axis preferences and canonical keyboard movement.
(() => {
  const match = location.pathname.match(/\/products\/([^/?#]+)/);
  const handle = match ? match[1] : '';
  if (!window.SmoofProductProfiles?.isTestProfile?.(handle)) return;
  if (window.__smoofLogoDuplicateV20Build324) return;
  window.__smoofLogoDuplicateV20Build324 = true;
  window.__smoofLogoDuplicateV20 = true;

  const ITEM_ID = 'logo-2';
  const LOGO_2_OPTION_ID = '8fcfc7b6-6f0a-4407-be42-91d1a80509ce';
  const SELECT_EVENT = 'smoof:editor-select';
  const BASE_WIDTH = 0.2;
  const BASE_HEIGHT = 0.075;
  const SAFE_RADIUS = 0.3434;
  const DEFAULTS = { enabled: false, visible: true, x: 0.67, y: 0.715, scale: 1, rotation: 0 };
  const state = { ...DEFAULTS };
  const source = { dataUrl: '', fileName: '', file: null };
  const PROPERTIES = {
    enabled: 'properties[_SMOOF Logo 2 aktiv]',
    visible: 'properties[_SMOOF Logo 2 sichtbar]',
    x: 'properties[_SMOOF Logo 2 X]',
    y: 'properties[_SMOOF Logo 2 Y]',
    scale: 'properties[_SMOOF Logo 2 Skalierung]',
    rotation: 'properties[_SMOOF Logo 2 Drehung]',
    fileName: 'properties[_SMOOF Logo 2 Dateiname]'
  };

  let overlay = null;
  let frame = null;
  let image = null;
  let controls = null;
  let guideX = null;
  let guideY = null;
  let currentStage = null;
  let selectedId = '';
  let hydrated = false;
  let renderPending = false;
  let drag = null;
  let imageReady = false;
  let logoAspectRatio = BASE_WIDTH / BASE_HEIGHT;

  function logoSource() { return source; }

  function logoBoxDimensions() {
    if (!source.dataUrl || !Number.isFinite(logoAspectRatio) || logoAspectRatio <= 0) {
      return { width: BASE_WIDTH, height: BASE_HEIGHT };
    }
    const baseAspect = BASE_WIDTH / BASE_HEIGHT;
    return logoAspectRatio >= baseAspect
      ? { width: BASE_WIDTH, height: BASE_WIDTH / logoAspectRatio }
      : { width: BASE_HEIGHT * logoAspectRatio, height: BASE_HEIGHT };
  }

  function optionRoot() {
    const roots = Array.from(document.querySelectorAll(`[data-option-id="${LOGO_2_OPTION_ID}"]`));
    return roots.find(root => root.offsetParent !== null) || roots[0] || null;
  }

  function fileInput() {
    return optionRoot()?.querySelector('input[type="file"]') || null;
  }

  function isLogo2OptionVisible() {
    const root = optionRoot();
    return Boolean(root && root.offsetParent !== null);
  }

  function placeholderColor() {
    const original = Array.from(document.querySelectorAll('[data-smoof-logo-placeholder]'))
      .find(candidate => !candidate.closest('[data-smoof-logo-instance="2"]'));
    if (original) {
      const color = getComputedStyle(original).color;
      if (color && color !== 'rgba(0, 0, 0, 0)') return color;
    }
    const value = document.querySelector('[data-option-id="dcde59d1-5fef-4e99-8d22-30e2ec19197e"] input[type="color"]')?.value || '#000000';
    const match = String(value).match(/^#([0-9a-f]{6})$/i);
    if (!match) return '#ffffff';
    const number = Number.parseInt(match[1], 16);
    const brightness = ((number >> 16) & 255) * 0.299 + ((number >> 8) & 255) * 0.587 + (number & 255) * 0.114;
    return brightness > 155 ? '#1b1b1b' : '#ffffff';
  }

  function announceFileChange() {
    window.dispatchEvent(new CustomEvent('smoof:logo-2-file-changed', {
      detail: { hasLogo: Boolean(source.dataUrl), fileName: source.fileName }
    }));
  }

  function readFile(input) {
    const file = input?.files?.[0];
    if (!file) {
      source.dataUrl = '';
      source.fileName = '';
      source.file = null;
      state.enabled = false;
      logoAspectRatio = BASE_WIDTH / BASE_HEIGHT;
      notify();
      announceFileChange();
      return;
    }
    const supported = file.type.startsWith('image/') || /\.(png|jpe?g|webp|svg)$/i.test(file.name);
    if (!supported) return;
    const reader = new FileReader();
    reader.addEventListener('load', () => {
      source.dataUrl = String(reader.result || '');
      source.fileName = file.name;
      source.file = file;
      state.enabled = true;
      state.visible = true;
      notify();
      announceFileChange();
    });
    reader.readAsDataURL(file);
  }

  function openUpload() {
    const input = fileInput();
    input?.click();
    return Boolean(input);
  }

  function removeFile() {
    const input = fileInput();
    if (input) {
      input.value = '';
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    } else {
      source.dataUrl = '';
      source.fileName = '';
      source.file = null;
      state.enabled = false;
      notify();
      announceFileChange();
    }
    return true;
  }

  function productForm() {
    return Array.from(document.querySelectorAll('form[action*="/cart/add"]'))
      .find(form => form.querySelector('button[type="submit"]')) || null;
  }

  function propertyInput(name) {
    return Array.from((productForm() || document).querySelectorAll('input'))
      .find(input => input.name === name) || null;
  }

  function setProperty(name, value) {
    const form = productForm();
    if (!form) return;
    let input = propertyInput(name);
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.dataset.smoofLogoDuplicateProperty = 'true';
      form.appendChild(input);
    }
    input.value = String(value);
  }

  function readNumber(name, fallback) {
    const value = Number.parseFloat(propertyInput(name)?.value);
    return Number.isFinite(value) ? value : fallback;
  }

  function readBoolean(name, fallback) {
    const value = propertyInput(name)?.value;
    return value == null || value === '' ? fallback : !/^(0|false|nein|no)$/i.test(value);
  }

  function hydrate() {
    if (hydrated || !productForm()) return;
    state.enabled = readBoolean(PROPERTIES.enabled, false);
    state.visible = readBoolean(PROPERTIES.visible, true);
    state.x = readNumber(PROPERTIES.x, DEFAULTS.x);
    state.y = readNumber(PROPERTIES.y, DEFAULTS.y);
    state.scale = readNumber(PROPERTIES.scale, DEFAULTS.scale);
    state.rotation = readNumber(PROPERTIES.rotation, DEFAULTS.rotation);
    hydrated = true;
  }

  function syncProperties() {
    hydrate();
    const source = logoSource();
    setProperty(PROPERTIES.enabled, state.enabled && Boolean(source.dataUrl) ? 'Ja' : 'Nein');
    setProperty(PROPERTIES.visible, state.visible ? 'Ja' : 'Nein');
    setProperty(PROPERTIES.x, state.x.toFixed(4));
    setProperty(PROPERTIES.y, state.y.toFixed(4));
    setProperty(PROPERTIES.scale, state.scale.toFixed(4));
    setProperty(PROPERTIES.rotation, state.rotation.toFixed(1));
    setProperty(PROPERTIES.fileName, source.fileName || '');
  }

  function constrain() {
    const dimensions = logoBoxDimensions();
    const extents = window.SmoofSpatialConstraints?.rotatedHalfExtents(
      dimensions.width * state.scale,
      dimensions.height * state.scale,
      state.rotation
    );
    if (!extents) return;
    const next = window.SmoofSpatialConstraints.constrainRect({
      x: state.x,
      y: state.y,
      ...extents,
      radius: SAFE_RADIUS
    });
    state.x = next.x;
    state.y = next.y;
  }

  function select() {
    window.dispatchEvent(new CustomEvent(SELECT_EVENT, { detail: { id: ITEM_ID } }));
  }

  function setGuides(showX, showY, x = 0.5, y = 0.5) {
    const sharedGuides = window.SmoofAlignmentGuides;
    if (sharedGuides) {
      if (guideX) guideX.style.display = 'none';
      if (guideY) guideY.style.display = 'none';
      if (showX) sharedGuides.showX(x);
      else sharedGuides.hideX();
      if (showY) sharedGuides.showY?.(y);
      else sharedGuides.hideY?.();
    } else if (guideX) {
      guideX.style.left = `${x * 100}%`;
      guideX.style.display = showX ? 'block' : 'none';
    }
    if (guideY) guideY.style.display = showY ? 'block' : 'none';
  }

  function updateFrame() {
    if (!frame) return;
    hydrate();
    constrain();
    const optionVisible = isLogo2OptionVisible();
    const source = logoSource();
    const dimensions = logoBoxDimensions();
    const width = dimensions.width * state.scale;
    const height = dimensions.height * state.scale;
    const hasLogo = Boolean(source.dataUrl);
    const showFrame = optionVisible && state.enabled && state.visible && hasLogo;
    frame.style.left = `${(state.x - width / 2) * 100}%`;
    frame.style.top = `${(state.y - height / 2) * 100}%`;
    frame.style.width = `${width * 100}%`;
    frame.style.height = `${height * 100}%`;
    frame.style.transform = `rotate(${state.rotation}deg)`;
    frame.style.display = showFrame ? 'block' : 'none';
    frame.style.pointerEvents = showFrame ? 'auto' : 'none';
    frame.dataset.active = String(selectedId === ITEM_ID);
    frame.dataset.hasLogo = String(hasLogo);
    if (source.dataUrl && image?.src !== source.dataUrl) {
      imageReady = false;
      image.src = source.dataUrl;
    }
    if (!source.dataUrl) imageReady = false;
    const showLogo = Boolean(source.dataUrl && imageReady);
    if (image) image.style.display = showLogo ? 'block' : 'none';
    const placeholder = frame.querySelector('[data-smoof-logo-2-placeholder]');
    if (placeholder) {
      placeholder.style.setProperty('display', 'none', 'important');
      placeholder.style.setProperty('visibility', 'hidden', 'important');
      placeholder.style.color = placeholderColor();
    }
    syncProperties();
  }

  function control(label, action, aria) {
    const button = document.createElement('button');
    button.type = 'button';
    button.textContent = label;
    button.dataset.smoofLogoControlButton = action;
    button.setAttribute('aria-label', aria);
    button.addEventListener('pointerdown', event => event.stopPropagation());
    return button;
  }

  function ensureOverlay(stage) {
    if (overlay?.isConnected && currentStage === stage) return;
    overlay?.remove();
    overlay = document.createElement('div');
    overlay.dataset.smoofLogoDuplicateOverlay = 'true';
    Object.assign(overlay.style, { position: 'absolute', inset: '0', zIndex: '66', pointerEvents: 'none', overflow: 'hidden' });
    guideX = document.createElement('div');
    guideX.dataset.smoofSnapGuide = 'x';
    guideY = document.createElement('div');
    guideY.dataset.smoofSnapGuide = 'y';
    frame = document.createElement('div');
    frame.dataset.smoofLogoEditorFrame = 'true';
    frame.dataset.smoofLogoInstance = '2';
    frame.dataset.smoofEditorItem = ITEM_ID;
    Object.assign(frame.style, { position: 'absolute', display: 'none', pointerEvents: 'auto', transformOrigin: 'center center', borderRadius: '6px' });
    image = document.createElement('img');
    image.alt = '';
    image.draggable = false;
    Object.assign(image.style, { width: '100%', height: '100%', objectFit: 'contain', pointerEvents: 'none', userSelect: 'none' });
    image.addEventListener('load', () => {
      imageReady = image.naturalWidth > 0 && image.naturalHeight > 0;
      if (imageReady) logoAspectRatio = image.naturalWidth / image.naturalHeight;
      updateFrame();
    });
    image.addEventListener('error', () => {
      imageReady = false;
      logoAspectRatio = BASE_WIDTH / BASE_HEIGHT;
      updateFrame();
    });
    const placeholder = document.createElement('div');
    placeholder.setAttribute('data-smoof-logo-2-placeholder', 'true');
    placeholder.dataset.smoofLogoPlaceholder = 'true';
    const placeholderLabel = document.createElement('span');
    placeholderLabel.dataset.smoofLogoPlaceholderLabel = 'true';
    placeholderLabel.appendChild(document.createTextNode('LOGO'));
    const placeholderBadge = document.createElement('span');
    placeholderBadge.dataset.smoofLogoPlaceholderBadge = 'true';
    placeholderBadge.textContent = '2';
    placeholderLabel.appendChild(placeholderBadge);
    placeholder.appendChild(placeholderLabel);
    Object.assign(placeholder.style, {
      position: 'absolute',
      inset: '1px',
      boxSizing: 'border-box',
      alignItems: 'center',
      justifyContent: 'center',
      border: '1px dashed currentColor',
      borderRadius: '6px',
      background: 'transparent',
      opacity: '0.72',
      pointerEvents: 'none'
    });
    Object.assign(placeholderLabel.style, {
      display: 'inline-flex',
      gap: '0.32em',
      alignItems: 'center',
      fontFamily: 'Arial, sans-serif',
      fontSize: 'clamp(10px, 1.4vw, 14px)',
      fontWeight: '700',
      letterSpacing: '0.04em',
      lineHeight: '1',
      whiteSpace: 'nowrap',
      visibility: 'visible'
    });
    Object.assign(placeholderBadge.style, {
      display: 'inline-grid',
      placeItems: 'center',
      width: '1.35em',
      height: '1.35em',
      boxSizing: 'border-box',
      border: '1px solid currentColor',
      borderRadius: '50%',
      fontSize: '0.68em',
      fontWeight: '800',
      letterSpacing: '0',
      lineHeight: '1'
    });
    controls = document.createElement('div');
    controls.dataset.smoofLogoControls = 'true';
    controls.dataset.smoofLogoDuplicateControls = 'true';
    const minus = control('−', 'minus', 'Zweites Logo verkleinern');
    const plus = control('+', 'plus', 'Zweites Logo vergrößern');
    controls.append(minus, plus);
    frame.append(image, placeholder, controls);
    overlay.append(guideX, guideY, frame);
    stage.appendChild(overlay);
    currentStage = stage;

    const scaleBy = amount => {
      state.scale = Math.max(0.1, Math.min(4, state.scale + amount));
      select();
      updateFrame();
      window.SmoofDesignRenderer?.scheduleRender?.();
    };
    minus.addEventListener('click', event => { event.stopPropagation(); scaleBy(-0.1); });
    plus.addEventListener('click', event => { event.stopPropagation(); scaleBy(0.1); });

    frame.addEventListener('pointerdown', event => {
      if (event.target.closest('[data-smoof-logo-controls]')) return;
      if (selectedId !== ITEM_ID) {
        select();
        event.preventDefault();
        event.stopPropagation();
        return;
      }
      drag = { id: event.pointerId, startClientX: event.clientX, startClientY: event.clientY, startX: state.x, startY: state.y };
      frame.setPointerCapture?.(event.pointerId);
      event.preventDefault();
    });
    frame.addEventListener('pointermove', event => {
      if (!drag || drag.id !== event.pointerId) return;
      const rect = currentStage.getBoundingClientRect();
      state.x = drag.startX + (event.clientX - drag.startClientX) / rect.width;
      state.y = drag.startY + (event.clientY - drag.startClientY) / rect.height;
      constrain();
      const sharedGuides = window.SmoofAlignmentGuides;
      const guideAtX = sharedGuides
        ? sharedGuides.nearestX(state.x, 0.012)
        : Math.abs(state.x - 0.5) <= 0.012
          ? 0.5
          : null;
      const guideAtY = sharedGuides?.nearestY?.(state.y, 0.012) ?? null;
      const snapX = Number.isFinite(guideAtX);
      const snapY = Number.isFinite(guideAtY);
      if (snapX) state.x = guideAtX;
      if (snapY) state.y = guideAtY;
      constrain();
      const acceptedX = snapX && Math.abs(state.x - guideAtX) < 0.001;
      const acceptedY = snapY && Math.abs(state.y - guideAtY) < 0.001;
      setGuides(acceptedX, acceptedY, guideAtX, guideAtY);
      updateFrame();
      window.SmoofDesignRenderer?.scheduleRender?.();
      event.preventDefault();
    });
    const finish = event => {
      if (!drag || drag.id !== event.pointerId) return;
      drag = null;
      setGuides(false, false);
      syncProperties();
      frame.releasePointerCapture?.(event.pointerId);
    };
    frame.addEventListener('pointerup', finish);
    frame.addEventListener('pointercancel', finish);
    frame.addEventListener('lostpointercapture', finish);
  }

  function render() {
    const stage = document.querySelector('.po-livePreview-stage .konvajs-content');
    if (!stage) {
      overlay?.remove();
      overlay = frame = image = controls = guideX = guideY = currentStage = null;
      return;
    }
    ensureOverlay(stage);
    updateFrame();
  }

  function scheduleRender() {
    if (renderPending) return;
    renderPending = true;
    requestAnimationFrame(() => requestAnimationFrame(() => {
      renderPending = false;
      render();
    }));
  }

  function notify() {
    scheduleRender();
    syncProperties();
    window.SmoofDesignRenderer?.scheduleRender?.();
    window.dispatchEvent(new CustomEvent('smoof:logo-duplicate-changed', { detail: { ...state } }));
  }

  window.SmoofLogoDuplicateTools = Object.freeze({

    nudge(dx, dy) {
      if (!state.enabled || !state.visible) return false;
      state.x += dx; state.y += dy;
      constrain(); notify();
      return true;
    },
    getState() {
      const source = logoSource();
      return { ...state, hasLogo: Boolean(source.dataUrl), src: source.dataUrl || '', dataUrl: source.dataUrl || '', fileName: source.fileName || '', file: source.file || null };
    },
    getHistoryState() {
      return { ...state, dataUrl: source.dataUrl, fileName: source.fileName, file: source.file };
    },
    applyHistoryState(next) {
      if (!next) return false;
      Object.assign(state, DEFAULTS, next);
      source.dataUrl = String(next.dataUrl || '');
      source.fileName = String(next.fileName || '');
      source.file = next.file instanceof File ? next.file : null;
      notify();
      return true;
    },
    isVisible() {
      return state.visible;
    },
    toggleVisibility() {
      state.visible = !state.visible;
      notify();
      return state.visible;
    },
    toggleEnabled() {
      state.enabled = !state.enabled;
      state.visible = true;
      notify();
      return state.enabled;
    },
    setEnabled(value) {
      state.enabled = Boolean(value);
      notify();
      return state.enabled;
    },
    adjustScale(amount) {
      state.scale = Math.max(0.1, Math.min(4, state.scale + Number(amount || 0)));
      notify();
      return state.scale;
    },
    resetPosition() {
      Object.assign(state, { x: DEFAULTS.x, y: DEFAULTS.y, scale: 1, rotation: 0, visible: true });
      notify();
    },
    openUpload,
    remove: removeFile
  });

  document.addEventListener('change', event => {
    const input = event.target;
    if (input instanceof HTMLInputElement && input.type === 'file' && input.closest(`[data-option-id="${LOGO_2_OPTION_ID}"]`)) {
      readFile(input);
    }
  }, true);

  window.addEventListener(SELECT_EVENT, event => {
    selectedId = String(event.detail?.id || '');
    updateFrame();
  });
  window.addEventListener('smoof:editor-reset-all', () => {
    Object.assign(state, DEFAULTS);
    notify();
  });
  window.addEventListener('smoof:editor-reset-layout', () => {
    Object.assign(state, {
      x: DEFAULTS.x,
      y: DEFAULTS.y,
      scale: DEFAULTS.scale,
      rotation: DEFAULTS.rotation
    });
    notify();
  });
  window.addEventListener('smoof:editor-reset-content', () => {
    Object.assign(state, DEFAULTS);
    removeFile();
  });
  window.addEventListener('smoof:logo-visibility-changed', scheduleRender);
  window.addEventListener('smoof:qr-geometry-change', scheduleRender);
  window.addEventListener('pointerup', event => {
    if (drag?.id === event.pointerId) {
      drag = null;
      setGuides(false, false);
      syncProperties();
    }
  }, true);
  window.addEventListener('pointercancel', event => {
    if (drag?.id === event.pointerId) {
      drag = null;
      setGuides(false, false);
      syncProperties();
    }
  }, true);
  window.addEventListener('blur', () => {
    drag = null;
    setGuides(false, false);
    syncProperties();
  });
  document.addEventListener('change', scheduleRender, true);
  new MutationObserver(scheduleRender).observe(document.body, { childList: true, subtree: true });
  window.setInterval(scheduleRender, 500);
  scheduleRender();
})();
